<template>
  <div class="ma-5">
    <div class="manage-department-title title-notab pb-4 pt-4">
    อนุมัติการร้องขอใช้บริการ
    </div>
    <v-row class="pt-3 pb-0">
      <v-item-group
        mandatory
        v-model="tapSelect"
        @change="searchFilterData(), page=1"
      >
        <!-- <v-container> -->
          <v-row class="pa-3">
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }" >
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0 ma-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-format-list-bulleted</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ totalAll }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">คำร้องทั้งหมด</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FEF5E9' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#E9A016'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#E9A016' : '#FEF5E9' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-clock-time-four-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #E9A016;">{{ totalWaiting }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">{{mode=='approve'? 'รออนุมัติ':'รอรับทราบ'}}</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#00B0FF'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#00B0FF' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-timelapse</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #00B0FF;">{{ totalPending }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">กำลังดำเนินการ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#ECF8EA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#58A144'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#58A144' : '#ECF8EA' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-check-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #58A144;">{{ totalApproved }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">อนุมัติแล้ว</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12" v-show="mode=='approve'">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FBE5E4' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#D1392B'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#D1392B' : '#FBE5E4' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-close-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #D1392B;">{{ totalRejected }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ไม่อนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        <!-- </v-container> -->
      </v-item-group>
    </v-row>
    <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">หมายเลขคำร้องขอใช้บริการ</span>
      <v-text-field
        v-model="keywordRequestNo"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาหมายเลขคำร้องขอใช้บริการ"
        no-data-text="ไม่พบข้อมูล"
        v-on:keyup.enter="searchFilterData(), page=1"
        @click:clear="keywordRequestNo='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
    <span class="head-search-text">ชื่อ service</span>
        <v-autocomplete
          v-model="keywordServiceName"
          :items="itemsServices"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาชื่อ service"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordServiceName='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordServiceName.splice(keywordServiceName.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
    </v-col>
    <v-spacer/>
  </v-row>
    <v-row cols="12" sm="12" md="12" lg="12" class="row-menu-right mb-3 pr-3" style="margin-top: -50px;">
      <v-btn
        v-if="mode=='approve'"
        color="primary"
        outlined
        class="head-search-button mr-1"
        :disabled="!allowBtnReject"
        @click="clickReject()"
      >
      {{ textBtnNO }}
      </v-btn>
      <v-btn
        color="primary"
        class="head-search-button ml-1 white--text text--lighten-4"
        elevation="0"
        :disabled="!allowBtnApprove"
        @click="clickApprove()"
      >
      {{ textBtnOk }}
      </v-btn>
    </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-employee text-no-wrap table-approve"
        item-key="_id"
        v-model="selected"
        :headers="headers"
        :items="dataSource"
        :loading="loading"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="totalInServer || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        :single-select="singleSelect"
        :show-select="true"
        @input="checkAllowBtn()"
        @toggle-select-all="selectAllToggle"
        disable-sort
      >
        <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-checkbox
            v-if="((approveRole === 'user' && (item.requestStatusTH === 'รออนุมัติ')) || ((approveRole === 'super admin' || approveRole === 'admin') && (item.requestStatusTH === 'รออนุมัติ' || item.requestStatusTH === 'กำลังดำเนินการ')))"
            v-show="true"
            v-model="item.selected"
            :value="isSelected"
            hide-details
            class="ma-0"
            style="width: 0px;"
            @change="select($event)"
          />
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="statusList.filter(e => e.statusTH === item.requestStatusTH)[0].colorback"
            :text-color="statusList.filter(e => e.statusTH === item.requestStatusTH)[0].color"
          >
            <span>{{ item.requestStatusTH || '-' }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                icon
                tile
                class="ra-border-button mr-4 ml-1"
                @click="view(item)"
              >
              <v-icon dark color="primary" small>fa-eye</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ดูข้อมูล service</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
    <!-- <DialogShowDetail/> -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="344"
      max-height="232"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;">
            {{ mode=='approve'? workfor=='approve'? 'ต้องการอนุมัติคำร้องใช่ไหม':'ต้องการไม่อนุมัติคำร้องใช่ไหม':'ต้องการรับทราบคำร้องใช่ไหม' }}
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            {{ mode=='approve'? workfor=='approve'? 'คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำร้อง':'คุณแน่ใจหรือไม่ว่าไม่ต้องการอนุมัติคำร้อง':'คุญแน่ใจหรือไม่ว่าต้องการรับทราบคำร้อง' }}
          </span>
        </v-card-subtitle>
        <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น" v-if="mode=='approve'"></v-textarea>
        <v-card-actions class="justify-center pb-4">
           <v-btn
              color="primary"
              outlined
              class="head-search-button mr-4"
              width="83"
              @click="dialog = false"
            >
            ยกเลิก
            </v-btn>
            <v-btn
              color="primary"
              class="head-search-button ml-4 white--text text--lighten-4"
              elevation="0"
              width="83"
              @click="updateStatusApprove(workfor, mode, comment)"
            >
            ยืนยัน
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#ECF8EA"
      app
    >
      <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
        {{ workfor=='approve'? 'คุณได้ทำการอนุมัติคำร้องเรียบร้อย':'คุณได้ทำการไม่อนุมัติคำร้องเรียบร้อย' }}
      </span>
    </v-snackbar>
    <DialogShowRequestService/>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
// import DialogShowDetail from '../_dialog/dialogShowDetail'
import OverlayLoading from '../_template/OverlayLoading.vue'
import DialogShowRequestService from './_dialog/dialogShowRequestService'
// import { fetchAllRequestApproveEmployee } from '@/API/API'
const swal = require('sweetalert')
const axios = require('axios')
const moment = require('moment')
export default {
  name: 'tree',
  components: {
    OverlayLoading,
    // DialogShowDetail
    DialogShowRequestService
  },
  props: {
  },
  data () {
    return {
      dialog: false,
      workfor: 'approve',
      comment: '',
      snackbar: false,
      isAdmin: this.$store.state.user.role ? (this.$store.state.user.role).includes('administrator') : false,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      loading: false,
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 15,
        page: 1
      },
      textBtnOk: 'อนุมัติ',
      textBtnNO: 'ไม่อนุมัติ',
      statusList: [
        { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF', colorback: '#ECF9FF' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144', colorback: '#ECF8EA' },
        { status: 'waiting', statusTH: 'รออนุมัติ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'waiting', statusTH: 'รอรับทราบ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B', colorback: '#FBE5E4' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#999999', colorback: '#EEEEEE' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144', colorback: '#ECF8EA' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'left fixed',
          value: 'no',
          width: '70px',
          groupable: false,
          sortable: false,
          class: 'column-fix'
        },
        { text: 'หมายเลขคำร้องขอใช้บริการ', value: 'serviceNo', divider: true, align: 'left fixed', class: 'column-fix' },
        { text: 'ชื่อ-นามสกุล', value: 'requestByName' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'บริษัท', value: 'companyName' },
        { text: 'ประเภทคำร้องขอใช้บริการ', value: 'serviceType' },
        { text: 'ชื่อ Service', value: 'serviceName' },
        // { text: 'requestStatus', value: 'requestStatus' },
        { text: 'สถานะขอใช้บริการ', value: 'status' },
        { text: 'จัดการ', align: 'left', width: '5%', value: 'actions', sortable: false }
      ],
      selected: [],
      dataSource: [],
      serviceTypeList: [],
      requestStatusList: [],
      total: -1,
      perPage: 15,
      page: 1,
      textCondition: {
        new: 'เพิ่มบุคคล',
        transfer: 'ขอย้ายฝ่าย',
        resign: 'ขอลาออก',
        transferPosition: 'ย้ายตำแหน่ง',
        resignPosition: 'ลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      },
      tapSelect: 0,
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      approveRole: 'Admin',
      mode: 'approve',
      keywordRequestNo: '',
      keywordServiceName: [],
      keywordStatus: [],
      itemsServices: [],
      tapData: ['', 'waiting', 'pending', 'approve', 'cancel']
    }
  },
  async created () {
    this.loading = true
    this.approveRole = localStorage.approveRole.toLowerCase()
    await this.getSelector()
    await this.searchFilterData(this.filterData)
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageApprove')
    EventBus.$off('manageApproveSearch')
    this.loading = false
  },
  mounted () {
    EventBus.$on('manageApproveSearch', this.setFilter)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  computed: {
    myRole () {
      return localStorage.getItem('approveRole')
    },
    totalInServer () {
      var count = [this.totalAll, this.totalWaiting, this.totalPending, this.totalApproved, this.totalRejected]
      return count[this.tapSelect] || -1
    }
  },
  watch: {
  },
  methods: {
    async setApproveRole () {
      this.approveRole = localStorage.approveRole.toLowerCase()
      this.page = 1
      await this.getSelector()
      await this.searchFilterData()
    },
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    async getSelector () {
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/requestServiceSelector`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: { role: this.approveRole }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.itemsServices = response.data.serviceName || []
            } else {
              this.itemsServices = []
            }
          })
          .catch(function (thrown) {
            this.itemsServices = []
          })
      } catch (error) { } finally {
        this.keywordRequestNo = ''
        this.keywordServiceName = []
        this.loading = false
      }
    },
    async setFilter (value) {
      if (this.filterData.role) this.approveRole = this.filterData.role
      this.filterData = value
      var searchPayload = {
        companyName: this.filterData.companyName || [],
        groupCompanyName: this.filterData.groupCompanyName || [],
        position: this.filterData.position || [],
        reqEmployeeNo: this.filterData.reqEmployeeNo || '',
        requestType: this.filterData.requestType || [],
        role: this.filterData.role,
        searchNameAndEmpId: this.filterData.searchNameAndEmpId || '',
        status: this.filterData.status || [''],
        tab: this.filterData.tab,
        limit: this.perPage,
        page: this.page
      }
      this.searchFilterData(searchPayload)
    },
    async searchFilterData () {
      this.selected = []
      this.loading = true
      var searchKeys = {
        serviceNo: this.keywordRequestNo,
        serviceName: this.keywordServiceName,
        // serviceType: this.keywordServiceType,
        // requestStatus: this.keywordStatus,
        requestStatus: this.setObjFilter(this.tapData[this.tapSelect]),
        role: this.approveRole,
        limit: this.perPage,
        page: this.page
      }
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/getRequestServiceList`,
          method: 'POST',
          data: searchKeys,
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then(async (res) => {
            if (res.data.success === true) {
              this.totalAll = res.data.requestAllCount
              this.totalApproved = res.data.approveCount
              this.totalPending = res.data.pendingCount
              this.totalRejected = res.data.cancelCount
              this.totalWaiting = res.data.waitingCount
              await this.computeData(res.data.result)
              this.dataSource = res.data.result
            } else {
              this.dataSource = []
            }
          })
          .catch(function (thrown) {
            this.dataSource = []
          })
      } catch (error) { } finally {
        this.loading = false
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
        e.requestDate = moment(e.requestDate).format('DD/MM/YYYY HH:mm น.')
        e.selected = false
        e.requestStatusTH = e.requestStatus === 'waiting' ? 'รออนุมัติ'
          : e.requestStatus === 'approve' ? 'อนุมัติแล้ว'
            : e.requestStatus === 'cancel' ? 'ยกเลิก'
              : e.requestStatus === 'pending' ? 'กำลังดำเนินการ' : 'ไม่อนุมัติ'
      })
    },
    view (item) {
      // console.log(item)
      // EventBus.$emit('openDialogManageApprove', this.filterData.role, item)
      EventBus.$emit('opendialogRequestDetail', true, item)
    },
    createRequestService () {
      // console.log('createRequestService')
      // this.$router.push('/authorityservices/requestservicelist/create')
      this.$router.push('/authorityservices/myservicelist/create')
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    clickApprove () {
      this.comment = ''
      this.dialog = true
      this.workfor = this.mode === 'approve' ? 'approve' : 'acknowledge'
    },
    clickReject () {
      this.comment = ''
      this.dialog = true
      this.workfor = 'reject'
    },
    async updateStatusApprove (task, mode, comment) {
      const self = this
      var confirmList = []
      self.selected.forEach(e => {
        confirmList.push(
          {
            requestStatus: task,
            comment: comment,
            // role: ['Admin', 'Super Admin', 'admin'].includes(localStorage.approveRole) ? 'admin' : '',
            role: this.approveRole || '',
            _id: e._id
          }
        )
      })
      // console.log('confirmList', confirmList)
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/updateStatusRequestService`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          approveList: confirmList
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            // swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
            //   button: false,
            //   timer: 2000
            // })
            this.dialog = false
            this.snackbar = true
            this.page = 1
            self.searchFilterData(self.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    select (event) {
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          // if ((this.approveRole === 'Leader' && (item.requestStatusTH === 'รออนุมัติ' || item.requestStatusTH === 'รอรับทราบ')) || (this.approveRole === 'Admin' && item.requestStatusTH === 'กำลังดำเนินการ')) {
          //   self.selected.push(item)
          // }
          if ((this.approveRole === 'user' && (item.requestStatusTH === 'รออนุมัติ')) || ((this.approveRole === 'super admin' || this.approveRole === 'admin') && (item.requestStatusTH === 'รออนุมัติ' || item.requestStatusTH === 'กำลังดำเนินการ'))) {
            self.selected.push(item)
          }
        })
      } else this.selected = []
      // console.log('selectAllToggle', this.selected)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    }
  }
}
</script>

<style>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>

<style scoped>

.table-approve >>> table > tbody > tr > td:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(1) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 0;
}

.table-approve >>> table > tbody > tr > td:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(2) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 56px;
}

.table-approve >>> table > tbody > tr > td:nth-child(3),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 126px;
}

.table-approve >>> table > tbody > tr:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr:hover > td:nth-child(3) {
  background: #eeeeee;
}

.table-approve >>> table > thead > tr > th:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  background-color: #F8F9FB;
}

.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(3) {
  background: #f7f7f7;
}

.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(3) {
  background: #eeeeee;
}
</style>
